import { Divider, Grid, Typography } from "@mui/material";
import { FormattedMessage } from "react-intl";

export const NewMessagesSeparator = (props: { unreadMessageCount: number }) => {
	return (
		<Grid container direction="row" alignItems="center">
			<Grid item xs={3}>
				<Divider />
			</Grid>
			<Grid item xs={6} style={{ textAlign: "center" }}>
				<Typography>
					<FormattedMessage id="CHAT.new_message.separator" values={{ count: props.unreadMessageCount }} />
				</Typography>
			</Grid>
			<Grid item xs={3}>
				<Divider />
			</Grid>
		</Grid>
	);
};
